// Create a separate file for configurations, e.g., profileConfigs.ts
import i18next from 'i18next';
import { convertToBillingUrl } from '../../utils/getBillingBaseUrl';

export interface LanguageOption {
  value: string;
  label: string;
}

export interface UserProfileConfig {
  profile?: {
    showProfile?: boolean;
    type?: 'href' | 'custom';
    href?: string;
    customEvent?: string;
  };
  language?: {
    showLanguage?: boolean;
    customEvent?: string;
    options?: LanguageOption[];
  };
  logout?: {
    type?: 'href' | 'custom';
    href?: string;
    customEvent?: string;
  };
  customActions?: Array<{
    label: string;
    href?: string;
    customEvent?: string;
  }>;
}

export const getProfileConfigs = (): Record<string, UserProfileConfig> => ({
  billing: {
    profile: {
      showProfile: true,
      type: 'href',
      href: convertToBillingUrl(
        '/apps/PersonalSetting.do?isPersonalSetting=true',
      ),
    },
    language: {
      showLanguage: false,
    },
    logout: {
      type: 'href',
      href: convertToBillingUrl('/apps/logout.do'),
    },
  },
  revenue: {
    profile: {
      showProfile: false,
    },
    language: {
      showLanguage: true,
    },
    logout: {
      type: 'custom',
      customEvent: 'revenue-logout',
    },
    customActions: [
      {
        label: i18next.t('GlobalNav.Profile.LoginHistory'),
        customEvent: 'login-history',
      },
      {
        label: i18next.t('GlobalNav.Profile.ReleaseLock'),
        customEvent: 'release-lock',
      },
      {
        label: i18next.t('GlobalNav.Profile.TableStyling'),
        customEvent: 'table-styling',
      },
      {
        label: i18next.t('ChatBot.Title.About'),
        customEvent: 'revenue-about',
      },
    ],
  },
  zephr: {
    profile: {
      showProfile: true,
      type: 'href',
      href: '/profile',
    },
    language: {
      showLanguage: false,
    },
    logout: {
      type: 'custom',
      customEvent: 'zephr-logout',
    },
    customActions: [
      {
        label: i18next.t('GlobalNav.Profile.AdminUsers'),
        href: '/admin-users',
      },
      {
        label: i18next.t('GlobalNav.Profile.Roles'),
        href: '/roles',
      },
      {
        label: i18next.t('GlobalNav.Profile.KeyPairs'),
        href: '/key-pairs',
      },
      {
        label: i18next.t('GlobalNav.Profile.LoginHistory'),
        href: '/login-history',
      },
    ],
  },
});
